import React from 'react';
import { Form } from 'informed';
import PropTypes from 'prop-types';
import InputSelect from '../components/inputs/InputSelect';
import Logo from '../assets/images/logos/Logos';
import { ThemeContext } from '../contexts/ThemeContext';
import { withRouter } from 'react-router-dom';
import { API_HOST } from '../consts';
import axios from 'axios';
import grupo from '../assets/images/plurall_images/grupo.png';
import instituicaoImg from '../assets/images/plurall_images/instituicaoImg.png';
import redeImg from '../assets/images/plurall_images/redeImg.png';
import dreImg from '../assets/images/plurall_images/dreImg.png';
import { toast } from 'react-toastify';
import { isNull } from 'lodash';
import { group } from 'd3';

class InstitutionSelectionPage extends React.Component {
  state = {
    institutionSelect: undefined,
    institutions: []
  };

  saveUserValues() {
    const {
      groupProfileSelect,
      redeSelect,
      dreSelect,
      institutionSelect,
      permissionSelect
    } = this.state;
    let payloadPermissions = {
      perfil: groupProfileSelect,
      rede: redeSelect,
      dre: dreSelect,
      instituicao: institutionSelect,
      permissions: permissionSelect
    };
    localStorage.setItem(
      'payload_permissions',
      JSON.stringify(payloadPermissions)
    );
  }

  handleSubmit = () => {
    this.saveUserValues();
    const { history } = this.props;
    const { groupProfileSelect } = this.state;
    if (groupProfileSelect == undefined) {
      toast.error('Selecione um grupo para acessar a plataforma');
    } else {
      if (
        groupProfileSelect.value !== 'Aluno' &&
        groupProfileSelect.value !== 'Responsavel'
      ) {
        history.push('/');
      } else {
        window.location.href =
          'https://exams-plurall-2022.citecnologia.com.br/';
      }
    }
  };

  fetchMe() {
    const token = localStorage.getItem('token');
    axios
      .get(`${API_HOST}/login/me`, {
        headers: {
          Authorization: `JWT ${token}`
        }
      })
      .then((response) => {
        this.setState({ me: response.data });
        this.fetchGroupProfile(response.data.id);
      })
      .catch((response) => toast.error(response.error));
  }

  fetchGroupProfile(me) {
    const token = localStorage.getItem('token');
    axios
      .get(`${API_HOST}/login/user/${me}`, {
        headers: {
          Authorization: `JWT ${token}`
        }
      })

      .then((response) => {
        this.setState({
          groupProfile: response.data.groups.map((x) => ({
            id: x.id,
            value: x.name,
            label: x.name
          }))
        });
      })
      .catch((response) => toast.error(response.error));
  }

  fetchInstitution(me, cargo, rede, dre) {
    const token = localStorage.getItem('token');
    axios
      .get(
        `${API_HOST}/core/rede_dre_inst?user_group_instituicao__usuario=${me}&instituicao__group=${cargo}&rede=${rede}&dre=${dre}`,
        {
          headers: {
            Authorization: `JWT ${token}`
          }
        }
      )

      .then((response) => {
        this.setState({
          institutions: response.data.map((x) => ({
            id: x.instituicao.instituicao.id,
            value: x.instituicao.instituicao.descricao,
            label: x.instituicao.instituicao.descricao
          }))
        });
      })
      .catch((response) => toast.error(response.error));
  }

  fetchDres(me, cargo, rede) {
    const token = localStorage.getItem('token');
    axios
      .get(
        `${API_HOST}/core/rede_dre_inst?user_group_instituicao__usuario=${me}&instituicao__group=${cargo}&${rede}`,
        {
          headers: {
            Authorization: `JWT ${token}`
          }
        }
      )

      .then((response) => {
        this.setState({
          dres: response.data.map((x) => ({
            id: x.dre.cd_dre,
            value: x.dre.ds_dre,
            label: x.dre.ds_dre
          }))
        });
      })
      .catch((response) => toast.error(response.error));
  }

  fetchRedes(me, cargo) {
    const token = localStorage.getItem('token');
    axios
      .get(
        `${API_HOST}/core/rede_dre_inst?user_group_instituicao__usuario=${me}&instituicao__group=${cargo}`,
        {
          headers: {
            Authorization: `JWT ${token}`
          }
        }
      )

      .then((response) => {
        this.setState({
          redes: response.data.map((x) => ({
            id: x.rede.id,
            value: x.rede.ds_rede,
            label: x.rede.ds_rede
          }))
        });
      })
      .catch((response) => toast.error(response.error));
  }

  fetchPermissions(me, cargo, rede, dre, instituicao) {
    const token = localStorage.getItem('token');
    axios
      .get(
        `${API_HOST}/core/rede_dre_inst?user_group_instituicao__usuario=${me}&instituicao__group=${cargo}&rede=${rede}&dre=${dre}&instituicao__instituicao=${instituicao}`,
        {
          headers: {
            Authorization: `JWT ${token}`
          }
        }
      )

      .then((response) => {
        this.setState({
          permissions: response.data[0].instituicao.group.permissions
        });
      })
      .catch((response) => toast.error(response.error));
  }

  componentDidMount() {
    this.fetchMe();
  }
  render() {
    const {
      permissions,
      permissionSelect,
      groupProfile,
      groupProfileSelect,
      institutionSelect,
      institutions,
      redes,
      redeSelect,
      dres,
      dreSelect,
      me,
      renderButton,
      renderRedes,
      renderDre,
      renderInst
    } = this.state;

    return (
      <>
        <ThemeContext.Consumer>
          {(theme) => (
            <section className="login-bg">
              <div className="container">
                <div className="box-form text-center">
                  <figure>
                    <img
                      src={theme.logoImg || Logo.client || Logo.main}
                      className="logo"
                      alt="logo-fgv"
                      title="2.0"
                      style={{ width: '70%', marginBottom: '10vh' }}
                    />
                  </figure>
                  <div>
                    <Form
                      onSubmit={this.handleSubmit}
                      // getApi={(formApi) => {
                      //   console.log(formApi);
                      // }}
                      initialValues={{ group: '', group: '' }}
                    >
                      <div className="form-sign">
                        <div className="group-input mb-4">
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              borderRadius: '16px',
                              boxShadow: '0px 1px 4px rgba(58, 58, 58, 0.25',
                              width: '450px',
                              height: '140px',
                              alignItems: 'center'
                            }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginLeft: '1rem',
                                width: '20%',
                                height: '80%'
                              }}
                            >
                              <img src={grupo} style={{ width: '100%' }} />
                            </div>
                            <div
                              style={{
                                width: '65%',
                                height: '50%',
                                marginLeft: '1rem'
                              }}
                            >
                              <h2
                                style={{
                                  marginRight: '80%',
                                  marginBottom: '10px'
                                }}
                              >
                                Perfil:
                              </h2>
                              <InputSelect
                                searchable={false}
                                col="col-sm-12"
                                options={groupProfile}
                                onChange={(e) => {
                                  if (e) {
                                    if (
                                      e.value === 'Aluno' ||
                                      e.value === 'Responsavel'
                                    ) {
                                      this.setState({ groupProfileSelect: e });
                                      this.setState({ renderButton: true });
                                      this.setState({ renderDre: false });
                                      this.setState({ renderInst: false });
                                      this.setState({ renderRedes: false });
                                    } else {
                                      this.setState({ renderButton: false });
                                      this.setState({ renderRedes: true });
                                      this.setState({ renderDre: false });
                                      this.setState({ renderInst: false });
                                      this.setState({ groupProfileSelect: e });
                                      this.fetchRedes(me.id, e.id);
                                    }
                                  } else {
                                    this.fetchRedes(
                                      me.id,
                                      groupProfileSelect.id
                                    );
                                    return '';
                                  }
                                }}
                                field="groupProfileSelect"
                              />
                            </div>
                          </div>
                        </div>
                        {renderRedes ? (
                          <div className="group-input mb-4">
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                borderRadius: '16px',
                                boxShadow: '0px 1px 4px rgba(58, 58, 58, 0.25',
                                width: '450px',
                                height: '140px',
                                alignItems: 'center'
                              }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  marginLeft: '1rem',
                                  width: '20%',
                                  height: '80%'
                                }}
                              >
                                <img src={redeImg} style={{ width: '100%' }} />
                              </div>
                              <div
                                style={{
                                  width: '65%',
                                  height: '50%',
                                  marginLeft: '1rem'
                                }}
                              >
                                <h2
                                  style={{
                                    marginRight: '80%',
                                    marginBottom: '10px'
                                  }}
                                >
                                  Rede:
                                </h2>
                                <InputSelect
                                  searchable={false}
                                  col="col-sm-12"
                                  options={redes}
                                  onChange={(e) => {
                                    if (e) {
                                      this.setState({ redeSelect: e });
                                      this.fetchDres(
                                        me.id,
                                        groupProfileSelect.id,
                                        e.id
                                      );
                                      this.setState({ renderDre: true });
                                      this.setState({ renderInst: false });
                                      this.setState({ renderButton: false });
                                    } else {
                                      return '';
                                    }
                                  }}
                                  field="redeSelect"
                                />
                              </div>
                            </div>
                          </div>
                        ) : (
                          ''
                        )}
                        {renderDre ? (
                          <div className="group-input mb-4">
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                borderRadius: '16px',
                                boxShadow: '0px 1px 4px rgba(58, 58, 58, 0.25',
                                width: '450px',
                                height: '140px',
                                alignItems: 'center'
                              }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  marginLeft: '1rem',
                                  width: '20%',
                                  height: '80%'
                                }}
                              >
                                <img src={dreImg} style={{ width: '100%' }} />
                              </div>
                              <div
                                style={{
                                  width: '65%',
                                  height: '50%',
                                  marginLeft: '1rem'
                                }}
                              >
                                <h2
                                  style={{
                                    marginRight: '80%',
                                    marginBottom: '10px'
                                  }}
                                >
                                  DREs:
                                </h2>
                                <InputSelect
                                  searchable={false}
                                  col="col-sm-12"
                                  options={dres}
                                  onChange={(e) => {
                                    if (e) {
                                      this.setState({ dreSelect: e });
                                      this.setState({ renderInst: true });
                                      this.setState({ renderButton: false });
                                      this.fetchInstitution(
                                        me.id,
                                        groupProfileSelect.id,
                                        redeSelect.id,
                                        e.id
                                      );
                                    }
                                    if (dreSelect) {
                                    } else {
                                      return '';
                                    }
                                  }}
                                  field="dreSelect"
                                />
                              </div>
                            </div>
                          </div>
                        ) : (
                          ''
                        )}
                        {renderInst ? (
                          <div className="group-input mb-4">
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                borderRadius: '16px',
                                boxShadow: '0px 1px 4px rgba(58, 58, 58, 0.25',
                                width: '450px',
                                height: '140px',
                                alignItems: 'center'
                              }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  marginLeft: '1rem',
                                  width: '20%',
                                  height: '80%'
                                }}
                              >
                                <img
                                  src={instituicaoImg}
                                  style={{ width: '100%' }}
                                />
                              </div>
                              <div
                                style={{
                                  width: '65%',
                                  height: '50%',
                                  marginLeft: '1rem'
                                }}
                              >
                                <h2
                                  style={{
                                    marginRight: '80%',
                                    marginBottom: '10px'
                                  }}
                                >
                                  Instituição:
                                </h2>
                                <InputSelect
                                  searchable={false}
                                  col="col-sm-12"
                                  options={institutions}
                                  onChange={(e) => {
                                    if (e) {
                                      this.setState({ institutionSelect: e });
                                      this.setState({ renderButton: true });
                                      this.fetchPermissions(
                                        me.id,
                                        groupProfileSelect.id,
                                        redeSelect.id,
                                        dreSelect.id,
                                        e.id
                                      );
                                      if (institutionSelect) {
                                        this.setState({
                                          permissionSelect: permissions
                                        });
                                      }
                                    } else {
                                      return '';
                                    }
                                  }}
                                  field="institutionSelect"
                                />
                              </div>
                            </div>
                          </div>
                        ) : (
                          ''
                        )}
                        {renderButton ? (
                          <div className="action-login mt-3">
                            <button
                              type="submit"
                              className="btn btn-padrao bg-padrao"
                              style={{ margin: '0 auto' }}
                            >
                              ACESSAR
                            </button>
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
            </section>
          )}
        </ThemeContext.Consumer>
      </>
    );
  }
}

InstitutionSelectionPage.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired
};

export default withRouter(InstitutionSelectionPage);
